module.exports = __webpack_public_path__ + "static/img/chill_out_corner.a5097952.png";